<!--
	Copyright (c) 2017-present, flop! contributors
	SPDX-License-Identifier: AGPL-3.0-or-later
	https://framagit.org/flopedt/flopedt
-->

<template>
  <div class="temporary-placeholder">
    <Row arrangement="center"><Patou height="3rem" /></Row>
  </div>
</template>
<script setup lang="ts">
import Row from './uikit/layout/Row.vue'

import Patou from '@/assets/logos/patou-casse-cut.svg'
</script>
<style scoped>
.temporary-placeholder {
  height: 3rem;
  width: 50px;
  background-color: var(--color-background-accent);
  border-radius: 0.5rem;
}
</style>
